<template>
    <div>

        <el-row>
            <div class="left-justifying"><h3>设备管理</h3></div>

            <div class="right-justifying">
                <el-button v-if="addBtnVisible" type="info" plain size="small" @click="addFunc"><i
                        class="fa fa-plus-circle"></i> 新建
                </el-button>
                <el-button v-if="saveBtnVisible" type="info" plain size="small" @click="saveFunc"><i
                        class="fa fa-save"></i> 保存
                </el-button>
                <el-button v-if="modiBtnVisible" type="info" plain size="small" @click="modiFunc"><i
                        class="fa fa-pencil"></i> 修改
                </el-button>
                <el-button v-if="delBtnVisible" type="info" plain size="small" @click="delConfirmFunc"><i class="fa fa-times"></i> 删除
                </el-button>



                <el-button v-if="addBtnVisible"  type="info" plain size="small" @click="exportFunc"><i class="fa el-icon-download"></i> 导出
                </el-button>

                <el-upload v-if="addBtnVisible"
                        style="float: right; margin-left: 10px;"
                        class="upload-demo"
                        :action="uploadUrl"
                        :headers="headerData"
                        :http-request="uploadFile"
                        ref="uploadRef"
                        :limit="1"
                        >
                    <el-button type="info" plain size="small" ><i class="fa el-icon-upload2"></i> 导入
                    </el-button>
                </el-upload>
                <!--<el-button  type="info" plain size="small" @click="equipmentInfoFunc"><i class="fa el-icon-s-platform"></i> 设备数据报告-->
                <!--</el-button>-->
            </div>
        </el-row>

        <div class="panel">
            <div class="panel-body">
                <el-row>

                    <div v-if="paginationHidden" class="advanced-search-location">
                        <!--<AthubDropDownSearch :model="searchParams" :formWidth="800" v-if="true" size="mini" collapseTags-->
                                             <!--multiple>-->
                            <!--<el-form :model="searchParams" label-width="80px">-->
                                <!--<el-row type="flex" class="row-bg">-->
                                    <!--<el-col :span="11">-->
                                        <!--<el-form-item label="开始时间">-->
                                            <!--<el-date-picker v-model="searchParams.startDate" placeholder=">=" format="yyyy-MM-dd"-->
                                                            <!--value-format="yyyy-MM-dd" />-->
                                        <!--</el-form-item>-->
                                    <!--</el-col>-->
                                    <!--<el-col :span="11">-->
                                        <!--<el-form-item label="结束时间">-->
                                            <!--<el-date-picker v-model="searchParams.endDate" placeholder="<=" format="yyyy-MM-dd"-->
                                                            <!--value-format="yyyy-MM-dd"/>-->
                                        <!--</el-form-item>-->
                                    <!--</el-col>-->
                                <!--</el-row>-->
                            <!--</el-form>-->
                        <!--</AthubDropDownSearch>-->
                    </div>

                    <el-tabs v-model="activeTab" @tab-click="handle_tab_click" v-loading="loding" >
                        <el-tab-pane label="列表" name="table_tab">
                            <el-row class="bottom20">
                                <el-table :data="tableData" stripe style="width: 100%">
                                    <el-table-column prop="code" label="编号">
                                        <template slot="header" slot-scope="scope">
                                            编号<br>
                                            <el-input size="mini" class="width70"
                                                      v-model="searchParams.code"></el-input>
                                        </template>
                                        <template slot-scope="scope" >
                                            <el-button @click="queryDetailInfo(scope.row)"  type="text" size="mini">
                                                {{scope.row.code}}
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                    <el-table-column  label="数据中心" >
                                        <template slot="header" slot-scope="scope">
                                            数据中心<br>
                                            <sysroom-select @fetchAllSysrooms="fetchAllSysrooms"  @input="searchDcNumChange()" v-model="searchParams.roomId" size="mini" clearable></sysroom-select>
                                        </template>
                                        <template slot-scope="scope" >
                                            {{formatRoom(scope.row.roomId)}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="type" label="类型">
                                        <template slot="header" slot-scope="scope">
                                            类型<br>
                                            <dictionary-select  v-model="searchParams.type" :factory-name="'domain'" :params="'ASSETTYPE'" clearable filterable  size="mini"></dictionary-select>
                                        </template>
                                        <template slot-scope="scope">
                                            <dictionary-text :factory-name="'domain'" :params="'ASSETTYPE'" :value="scope.row.type"></dictionary-text>
                                        </template>
                                    </el-table-column>
                                    <el-table-column  label="供应商">
                                        <template slot="header" slot-scope="scope">
                                            供应商<br>
                                            <!--<el-select v-model="searchParams.vendorId" size="mini"  placeholder="请选择" clearable filterable  >-->
                                                <!--<el-option-->
                                                        <!--v-for="item in companies"-->
                                                        <!--:key="item.companiesid"-->
                                                        <!--:label="item.name"-->
                                                        <!--:value="item.companiesid">-->
                                                <!--</el-option>-->
                                            <!--</el-select>-->
                                            <el-input v-model="searchParams.vendorId" size="small"
                                                      class="width70"  style="display: none;"></el-input>
                                            <el-input v-model="searchParams.vendorNameFalse" size="mini"
                                                      class="width50" readOnly ="true" >
                                            </el-input>

                                            <el-button slot="append" icon="el-icon-delete" size="mini" style="float:right;padding:7px 6px;"
                                                       @click="deleteParam()" ></el-button>
                                            <el-button slot="append" icon="el-icon-edit-outline" size="mini" style="float:right;margin-right:9px;padding:7px 6px;"
                                                       @click="dialogCompanyVisible=true"></el-button>

                                        </template>
                                        <template slot-scope="scope" >
                                            {{formatComp(scope.row.vendorId)}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="description" label="描述">
                                        <template slot="header" slot-scope="scope">
                                            描述<br>
                                            <el-input size="mini" class="width70"
                                                      v-model="searchParams.description"></el-input>
                                        </template>
                                    </el-table-column>

                                    <el-table-column  label="位置">
                                        <template slot="header" slot-scope="scope">
                                            位置<br>
                                            <el-select v-model="searchParams.locationId" size="mini"  placeholder="请选择" clearable filterable  >
                                                <el-option
                                                        v-for="item in locations"
                                                        :key="item.locationid"
                                                        :label="item.description"
                                                        :value="item.locationid">
                                                </el-option>
                                            </el-select>
                                        </template>

                                        <template slot-scope="scope" >
                                            {{formatLocation(scope.row.locationId)}}
                                        </template>
                                    </el-table-column>

                                </el-table>
                            </el-row>
                        </el-tab-pane>
                        <el-tab-pane label="详情" name="detail_tab">
                            <div>
                                <el-row class="column-name" justify="start">
                                    <span>基本信息</span>
                                </el-row>
                                <el-form label-position="right" ref="formEle" :model="formEle" :rules="formEleRules"
                                         label-width="120px">
                                    <el-form-item label="" prop="id"  style="display: none;" >
                                    <el-input v-model="formEle.id" size="small" style="display: none;"
                                              class="width70"></el-input>
                                    </el-form-item>
                                    <el-row>
                                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                                            <el-form-item label="设备编号" prop="code">
                                                <el-input size="mini" style="width: 455px;" :disabled="disableFlag"
                                                          v-model="formEle.code"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                                            <el-form-item label="设备名称" prop="name">
                                                <el-input size="mini" style="width: 455px;" :disabled="disableFlag"
                                                          v-model="formEle.name"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>

                                    <el-row>
                                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                                            <el-form-item label="数据中心" prop="roomId">
                                                <sysroom-select  v-model="formEle.roomId" :disabled="disableFlag" @input="formEleDcNumChange()" style="width: 455px;" size="mini" ></sysroom-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                                            <el-form-item label="设备类型" prop="type">
                                                <dictionary-select  v-model="formEle.type" :disabled="disableFlag" :factory-name="'domain'" :params="'ASSETTYPE'" clearable filterable  size="mini"></dictionary-select>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>

                                    <el-row>
                                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                                            <el-form-item label="供应商" prop="vendorNameFalse">
                                                <!--<el-select v-model="formEle.vendorId" size="mini" style="width: 380px;"  placeholder="请选择" clearable filterable  >-->
                                                    <!--<el-option-->
                                                            <!--v-for="item in companies"-->
                                                            <!--:key="item.companiesid"-->
                                                            <!--:label="item.name"-->
                                                            <!--:value="item.companiesid">-->
                                                    <!--</el-option>-->
                                                <!--</el-select>-->
                                                <el-input v-model="formEle.vendorId" size="small"
                                                          class="width70"  style="display: none;"></el-input>
                                                <el-input v-model="formEle.vendorNameFalse" :disabled="disableFlag" size="mini"
                                                          style="width: 380px;"  readOnly ="true" >
                                                </el-input>
                                                <el-button  icon="el-icon-edit-outline" size="mini" :disabled="disableFlag"
                                                            @click="dialogCompanyVisible=true">选择</el-button>
                                            </el-form-item>

                                        </el-col>
                                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                                            <el-form-item label="描述" prop="description">
                                                <el-input size="mini" style="width: 455px;" :disabled="disableFlag"
                                                          v-model="formEle.description"></el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>

                                    <el-row>
                                        <el-col :xs="24" :sm="24" :md="12" :lg="12">
                                            <el-form-item label="位置" prop="locationId">
                                                <el-select v-model="formEle.locationId" :disabled="disableFlag" size="mini" style="width: 455px;" placeholder="请选择" clearable filterable  >
                                                    <el-option
                                                            v-for="item in formLocations"
                                                            :key="item.locationid + ''"
                                                            :label="item.description"
                                                            :value="item.locationid + ''">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>

                                    </el-row>
                                </el-form>
                            </div>

                            <div v-if="propertyShow">
                                <equipmentPropertyValuePanel :row-id="formEle.id">

                                </equipmentPropertyValuePanel>
                            </div>


                            <div>
                                <el-row class="column-name" justify="start">
                                    <span>点位列表</span>
                                </el-row>
                                <el-table :data="pointTable"  highlight-current-row   :max-height="300" :fit="true" :stripe="true" style="width: 100%">

                                    <el-table-column prop="code" label="点位编号">
                                        <template slot="header" slot-scope="scope">
                                            点位编号<br>
                                            <el-input size="mini" class="width70"
                                                      v-model="pointParams.pointCode"></el-input>
                                        </template>
                                        <template slot-scope="scope" >
                                            <el-button @click="toPointUrl(scope.row)"  type="text" size="mini">
                                                {{scope.row.code}}
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="name" label="点位标签" >
                                        <template slot="header" slot-scope="scope">
                                            点位标签<br>
                                            <el-input size="mini" class="width70"
                                                      v-model="pointParams.pointName"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="type" label="点位类型">
                                        <template slot="header" slot-scope="scope">
                                            点位类型<br>
                                            <asset-attribute-select ref="pointTypeRefEq" v-model="pointParams.pointType"
                                                                     :size="mini"></asset-attribute-select>
                                        </template>
                                        <template slot-scope="scope">
                                            {{scope.row.pointTypeId | pointTypeFilter}}
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="description" label="描述">
                                        <template slot="header" slot-scope="scope">
                                            描述<br>
                                            <el-input size="mini" class="width70"
                                                      v-model="pointParams.pointDescription"></el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="realTimeValue" label="实时值">
                                        <template slot="header" slot-scope="scope">
                                            实时值<br>

                                        </template>
                                    </el-table-column>
                                </el-table>
                                <el-row type="flex" class="row-bg" justify="end" v-if="!paginationHidden">
                                    <el-pagination align="right" @size-change="handleSizeChangePoint"
                                                   @current-change="handleCurrentChangePoint"
                                                   :current-page="currentPagePoint"
                                                   :page-sizes="pageSizesPoint" :page-size="pageSizePoint"
                                                   layout="total, sizes, prev, pager, next, jumper"
                                                   :total="totalPoint">
                                    </el-pagination>
                                </el-row>
                            </div>
                            <div v-if="true">
                                <equipmentGroupPanel :item-id="formEle.id">

                                </equipmentGroupPanel>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </el-row>

                <el-row type="flex" class="row-bg" justify="end" v-if="paginationHidden">
                    <el-pagination align="right" @size-change="handleSizeChange"
                                   @current-change="handleCurrentChange"
                                   :current-page="currentPage"
                                   :page-sizes="pageSizes" :page-size="pageSize"
                                   layout="total, sizes, prev, pager, next, jumper"
                                   :total="total">
                    </el-pagination>
                </el-row>
            </div>
        </div>
        <CompanyDialog :dialogCompanyVisible.sync="dialogCompanyVisible" @afterCompanyDialogFunc="afterCompanyDialogFunc"></CompanyDialog>
    </div>

</template>

<script type="text/javascript">
    import CompanyServer from '../../api/company/index'
    import CompanyDialog from '@/views/company/company_dialog'
    import SysroomSelect from '@/components/sysroom'
    import AthubDropDownSearch from '@/components/common/athub.dropdown.search'
    import DictionarySelect from '@/components/common/DictionarySelect'
    import DictionaryText from '@/components/common/DictionaryText'
    import {debounce} from '@/util/common/debounce.js'
    import {queryPage,queryLocations,add,queryDetail,update,deleteId,exportExcel,importExcel
    } from '@/api/equipment/equipment-list.js'
    import {queryPointByEquipment
    } from '@/api/equipment/equipmentPoint.js'
    import point from '@/api/equipment/point/index'
    import {DCIM_SERVER, ASSET_SERVER} from '@/api/server'
    import equipmentPropertyValuePanel from '@/views/dcim/equipment-property/equipment-property-value-panel'
    import equipmentGroupPanel from '@/views/dcim/equipment/equipment-equipment-group-panel'
    import AssetAttributeSelect from '@/components/dcim/asset-attribute-select'
    let that;
    export default {
        name: 'equipment',
        components: {
            AthubDropDownSearch,SysroomSelect,DictionarySelect,DictionaryText,CompanyDialog,equipmentPropertyValuePanel,equipmentGroupPanel,AssetAttributeSelect
        },
        data() {
            return {
                loding:true,
                fileList:[],//导入excel集合
                headerData:{'appId':'WEB','token':localStorage.getItem("token")},//上传头部携带token
                uploadUrl:`${DCIM_SERVER}/equipment/uploadExcel`,//导入路劲
                dialogCompanyVisible:false,//供应商
                propertyShow:false,//设备属性的新增界面
                rooms: [],//数据中心集合
                companies: [],//供应商集合,当前table页面对应的供应商
                companiesAll: [],//所有供应商集合
                companiesMap:null,//供应商MAP,当前table页面对应得供应商
                companiesMapAll:null,//所有供应商MAP
                locations: [],//查询页面位置集合
                formLocations: [],//FORM表单页面位置集合
                searchParams: {
                    code: null,
                    roomId:null,
                    type:null,
                    vendorId:null,
                    vendorNameFalse:null,
                    description:null,
                    locationId:null
                },

                //表格翻页查询条件
                currentPage: 1,
                pageSize: 10,
                pageSizes: [10, 25, 50, 100],
                total: 0,
                //当前Tab页
                activeTab: "table_tab",
                //分页根据不同TAB隐藏或者显示
                paginationHidden:true,

                //设备返回数据
                tableData: [],

                param: {},
                //按钮显示
                addBtnVisible: true,
                saveBtnVisible: false,
                modiBtnVisible: false,
                delBtnVisible: false,

                //FORM基本信息定义变量
                formEle: {
                    id: null,
                    code: null,
                    name: null,
                    roomId: null,
                    type: null,
                    vendorId: null,
                    vendorNameFalse:null,
                    description: null,
                    locationId:null,
                    createUserId:null
                },

                formEleRules: {
                    code: [{
                        required: true,
                        trigger: 'blur',
                        message: '请输入编号',
                    }],
                    name: [{
                        required: true,
                        trigger: 'blur',
                        message: '请输入名称',
                    }],
                    roomId: [{
                        required: true,
                        trigger: 'change',
                        message: '请选择数据中心',
                    }],
                    type: [{
                        required: true,
                        trigger: 'change',
                        message: '请选择类型',
                    }],
                    vendorId: [{
                        required: true,
                        trigger: 'change',
                        message: '请选择供应商',
                    }],
                    vendorNameFalse: [{
                        required: true,
                        trigger: 'change',
                        message: '请选择供应商',
                    }],
                    description: [{
                        required: true,
                        trigger: 'blur',
                        message: '请输入描述',
                    }],
                    locationId: [{
                        required: true,
                        trigger: 'change',
                        message: '请选择位置',
                    }]
                },

                //点位列表TABLE数据集合
                pointTable:[],
                //点位列表TABLE查询条件
                pointParams:{
                    pointCode:null,
                    pointName:null,
                    pointType:null,
                    pointDescription:null,
                    pointGuid:null
                },
                //表格翻页查询条件
                currentPagePoint: 1,
                pageSizePoint: 10,
                pageSizesPoint: [10, 25, 50, 100],
                totalPoint: 0,
                disableFlag:true,
            }

        },

        methods: {
            transferPointType(assetAttributes, value) {
                let desc = '';
                assetAttributes.forEach(e => {
                    if (e.assetattributeid == value) {
                    desc = e.assetattrid + '-' + e.description;
                    return;
                }
            })
                return desc;
            },
            handle_tab_click(tab, event) {
                this.activeTab = tab.name;
                if(this.activeTab=='table_tab'){
                    this.queryTable();
                }
                this.changeActiveTabControl();
                this.$refs.formEle.resetFields();
                this.pointTable=[];
                this.disableFlag=true;
                this.propertyShow=false;//显示设别属性界面
            },
            //查询页面供应商点击一行促发事件
            afterCompanyDialogFunc(row){
                if(this.activeTab=='table_tab'){
                    this.searchParams.vendorId=row.companiesid;
                    this.searchParams.vendorNameFalse=row.name;
                }else{
                    this.formEle.vendorId=row.companiesid;
                    this.formEle.vendorNameFalse=row.name;
                }


            },
            deleteParam(){
                this.searchParams.vendorId=null;
                this.searchParams.vendorNameFalse=null;
            },
            //相应页面自定义事件,由子页面this.$emit('fetchAllSysrooms', that.sysroomList);发起调用
            fetchAllSysrooms(rooms) {
                //rooms页面存储变量,供:formatter="formatRoom"循环转换TABLE对应的中文
                this.rooms = rooms;
            },
            formatRoom(dcNum) {
                let roomDesc = '';
                this.rooms.forEach(e => {
                    if (dcNum == e.id) {
                    roomDesc = e.name;
                }
            });
                return roomDesc;
            },
            formatComp(comP) {
                this.loding=true;
                let roomDesc = '';
//                this.companies.forEach(e => {
//                    if (comP == e.companiesid) {
//                    roomDesc = e.name;
//                }
//                this.loding=false;
//                });
                roomDesc=this.companiesMap.get(comP + '');
                this.loding=false;
                return roomDesc;
            },
            formatLocation(lo) {
                let roomDesc = '';
                this.locations.forEach(e => {
                    if (lo == e.locationid+'') {
                    roomDesc = e.description;
                }
            });
                return roomDesc;
            },

            handleSizeChange(val) {
                this.pageSize = val;
                this.queryTable();
            },

            handleCurrentChange(val) {
                this.currentPage = val;
                this.queryTable();
            },
            //查询
            async queryTable() {
                this.loding=true;
                let pageParams = {
                    'current': this.currentPage,
                    'size': this.pageSize,
                }
                let params = {
                        ...pageParams,'search':this.searchParams
                };


                var responseBody=await queryPage(params);

                this.total=responseBody.total;
                this.tableData=responseBody.records;
                this.loding=false;

                 var ids = new Array();
                    this.tableData.forEach(e=>{
                    ids.push(e.vendorId);
                })

                CompanyServer.company.getAllByIds(ids).then(responseBody => {

                    this.companies=responseBody;
                    this.companiesMap= new Map();
                    responseBody.forEach(e =>{
                        this.companiesMap.set(e.companiesid + '', e.name);
                    })
            });
            },

            //详情
            async queryDetailInfo(row) {

                this.activeTab = 'detail_tab';
                this.changeActiveTabControl();
                var detail=await queryDetail(row.id);

                this.formEle=detail;
                this.formEle.roomId=parseInt(detail.roomId);//因为后台返回的roomId是字符串，和下拉框里面存在的是INT的不匹配所以这边转换一下
                this.disableFlag=true;
                var vendorName=this.formatComp(detail.vendorId);
                this.formEle.vendorNameFalse=vendorName;
                this.propertyShow=true;//显示设别属性界面
                //获取点位列表信息
                this.queryTablePoint();
            },
            //TAB切换
            changeActiveTabControl() {

                if (this.activeTab == 'table_tab') {
                    this.addBtnVisible = true;
                    this.modiBtnVisible = false;
                    this.saveBtnVisible = false;
                    this.delBtnVisible = false;
                    this.paginationHidden=true;
                } else {
                    this.addBtnVisible = false;
                    this.modiBtnVisible = true;
                    this.saveBtnVisible = true;
                    this.delBtnVisible = true;
                    this.paginationHidden=false;
                }
            },

            //新增按钮
            async addFunc() {
                this.activeTab = 'detail_tab';
                this.changeActiveTabControl();
                this.$refs.formEle.resetFields();
                this.formEle.vendorNameFalse=null;//不知道为啥上面方法清除不掉，手动清除
                this.disableFlag=false;
                this.pointTable=[];
                this.propertyShow=false;//显示设别属性界面
            },
            //设备点位分页查询方法
            handleSizeChangePoint(val) {
                this.pageSizePoint = val;
                this.queryTablePoint();
            },
            //设备点位分页查询方法
            handleCurrentChangePoint(val) {
                this.currentPagePoint = val;
                this.queryTablePoint();
            },
            //设备点位查询方法
            async queryTablePoint(){
                let pageParams = {
                    'currentPage': this.currentPagePoint,
                    'pageSize': this.pageSizePoint,
                    'id' : this.formEle.id,
                }
                let params = {
                        ...pageParams,...this.pointParams
                };
                var responseBody=await queryPointByEquipment(params);

                let guids = responseBody.records.map(e=>e.guid);
                await point.getRealTimeValuesByGuids(guids).then(res2 => {
                    for (let i = 0; i < responseBody.records.length; i++) {
                        responseBody.records[i].realTimeValue = res2.data[i];
                    }
                    this.totalPoint=responseBody.total;
                    this.pointTable=responseBody.records;
                });
            },
            //查询页面数据中心下拉框选择变动促发事件
            async searchDcNumChange(){
                this.searchParams.locationId=null;
                //在查询对应得位置
                this.locations= await queryLocations(this.searchParams.roomId);

            },
            //新增页面数据中心下拉框选择变动促发事件
            async formEleDcNumChange(){
                this.formEle.locationId=null;
                //在查询对应得位置
                this.formLocations= await queryLocations(this.formEle.roomId);

            },
            //保存
            saveFunc() {
                this.$refs.formEle.validate(async(valid) => {
                    if (valid) {
                        if (this.formEle.id) {//修改保存
                            this.formEle.createUserId = localStorage.getItem("userid");
                            var response=await update(this.formEle);
                            if(response.data.code=='200'){
                                this.$message.success(response.data.message);
                            }else{//"471"
                                this.$message.success(response.data.message);
                            }
                        }else {//新增保存
                            this.formEle.createUserId = localStorage.getItem("userid");
                            var response=await add(this.formEle);
                            if(response.data.code=='200'){
                                this.formEle.id=response.data.data;
                                this.$message.success(response.data.message);
                                this.propertyShow=true;//显示设别属性界面
                            }else{//"471"
                                this.$message.success(response.data.message);
                            }

                        }
                    } else {
                        console.log('提交失败!!');
                        return false;
                    }
            });
            },
            //跳转去点位详情页面
            toPointUrl(row){
                 this.$router.push({name: 'point', query: {detail: 1,pointId:row.id}})
            },
            modiFunc() {
                if(!this.formEle.id){
                    this.$message.success('请先选择数据');
                    return;
                }
                this.disableFlag=false;

            },
            delConfirmFunc(){
                if(!this.formEle.id){
                    this.$message.success('请先选择数据');
                    return;
                }
                this.$confirm('删除此设备, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then( async() => {
                    this.formEle.createUserId = localStorage.getItem("userid");
                    var response=await deleteId(this.formEle.id,this.formEle.createUserId);
                    this.$message.success(response);
                    this.activeTab = 'table_tab';
                    this.queryTable();
                    this.changeActiveTabControl();
                }).catch(() => {
                        console.log('已取消删除');
                });
            },
            importFunc(){

            },
            exportFunc(){
                exportExcel(this.searchParams);
            },
            equipmentInfoFunc(){

            },
            uploadFile(e){
                let params = {
                    file: e.file,
                    type: 'equipment',
                }

                importExcel(params).then(res => {

                    if(res.code=='471'){
                        this.$message.error(res.message);
                        console.log(res.data);
                    }else{
                        this.$message.success(res.message);
                    }

                   // this.activeTab = 'table_tab';
                    this.queryTable();
                   // this.changeActiveTabControl();

                }).catch(error => {
                     this.$message.error(res.message);
                     console.log(res.data);
                });
                    this.$refs['uploadRef'].clearFiles();
            },



    },
    mounted() {
        that = this;
    },
    //指定异步方法
    async created() {
//        //先查询对应的可用的供应商
//         CompanyServer.company.getAllValidList().then(responseBody => {
//            this.companiesAll=responseBody;
//
//            this.companiesMapAll= new Map();
//            responseBody.forEach(e =>{
//                this.companiesMapAll.set(e.companiesid + '', e.name);
//            })
//        });
        //在查询对应得位置

        this.locations= await queryLocations(0);
        this.formLocations= this.locations;
        let pageParams = {
            'current': this.currentPage,
            'size': this.pageSize,
        }
        let params = {
            'search':this.searchParams, ...pageParams
        };
        //等待queryPage方法执行完毕
        var responseBody=await queryPage(params);

        this.total=responseBody.total;
        this.tableData=responseBody.records;
        this.loding=false;

        var ids = new Array();
        this.tableData.forEach(e=>{
            ids.push(e.vendorId);
        })

        CompanyServer.company.getAllByIds(ids).then(responseBody => {

                this.companies=responseBody;
                this.companiesMap= new Map();
                responseBody.forEach(e =>{
                    this.companiesMap.set(e.companiesid + '', e.name);
                })
        });


        //点位页面跳转设备详情
        if(null!=this.$route.query.detail&&this.$route.query.detail==1){
            var detail=await queryDetail(this.$route.query.equipmentId);
            //先查询对应的可用的供应商
            var ids = new Array();
            ids.push(detail.vendorId);
            CompanyServer.company.getAllByIds(ids).then(responseBody => {
                this.companiesAll=responseBody;

            this.companiesMapAll= new Map();
            responseBody.forEach(e =>{
                this.companiesMapAll.set(e.companiesid + '', e.name);
            })
            this.companiesMap=this.companiesMapAll;
            let equipmentId=this.$route.query.equipmentId;
            this.queryDetailInfo({'id':equipmentId});

        });


        }
    },
    computed: {

    },
    filters: {
        pointTypeFilter:function (value) {
            return that.transferPointType(that.$refs['pointTypeRefEq'].assetAttributes, value) || '';
        }
    },
    watch: {

        searchParams: {
            deep: true,
                    handler: debounce(function (newVal, oldVal) {
                this.currentPage = 1;
                this.total = 0;
                this.tableData = [];
                this.queryTable();
            }, 500)
        },
        pointParams: {
            deep: true,
                    handler: debounce(function (newVal, oldVal) {
                this.currentPagePoint = 1;
                this.totalPoint = 0;
                this.pointTable = [];
                this.queryTablePoint();
            }, 500)
        }

    },


    }

</script>